import { useLazyQuery } from '@apollo/client'
import { IGraphqlQueryProps } from '@dtos/Pagination'
import { GET_USER_CERTIFICATES } from '@services/api/graphql/queries/getUserCertificates'

interface IUseGetUserCertificatesProps extends IGraphqlQueryProps {}

export const useGetUserCertificates = ({
  offset,
  limit,
}: IUseGetUserCertificatesProps) => {
  const [getUserCertificates, { data, loading, error, variables, called }] =
    useLazyQuery(GET_USER_CERTIFICATES, {
      variables: { offset, limit },
      fetchPolicy: 'cache-and-network',
    })

  return { getUserCertificates, data, loading, error, variables, called }
}
